// Contesto globale per il conteggio delle notifiche non lette.
// Usato da UserLayout (badge nav) e da qualsiasi componente che
// esegue operazioni sulle notifiche (mark read, delete).
//
// Pattern:
//   - useNotifications() → legge unreadCount
//   - useNotifications().refresh() → ricarica il conteggio dal backend
//   - chiamare refresh() dopo ogni markRead / markAllRead / deleteOne / clearAll

import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import { notificationService } from '../services';

interface NotificationContextValue {
  unreadCount: number;
  refresh: () => Promise<void>;
}

const NotificationContext = createContext<NotificationContextValue>({
  unreadCount: 0,
  refresh: async () => {},
});

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [unreadCount, setUnreadCount] = useState(0);

  const refresh = useCallback(async () => {
    try {
      const notifications = await notificationService.getAll();
      setUnreadCount(notifications.filter((n) => !n.read).length);
    } catch {
      // token scaduto o errore rete: non crashare, lascia il valore precedente
    }
  }, []);

  // Carica al mount
  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <NotificationContext.Provider value={{ unreadCount, refresh }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationContext);
